import React, { useState, useEffect } from 'react';
import SupervisorLayout from '../../components/SupervisorLayout';
import SupervisorTicketsPerBankView from './SupervisorTicketsPerBankView';
import { fetchSupervisorMoveDetail } from '../../api/supervisor';
import './SupervisorMoveDetailView.css';

const SupervisorMoveDetailView = ({ row, date, rawDate, tirage, tirageName, bankId, groupId, onBack }) => {
  const [selectedBank, setSelectedBank] = useState(null);
  const [detail, setDetail] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    fetchSupervisorMoveDetail({ tirage, date: rawDate, product: row.game, numbers: row.numero, bank: bankId, group: groupId })
      .then((data) => { if (!cancelled) setDetail(data); })
      .catch(() => { if (!cancelled) setError('Impossible de charger le detail — verifie que le serveur backend tourne.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [tirage, rawDate, row.game, row.numero, bankId, groupId]);

  if (selectedBank) {
    return (
      <SupervisorTicketsPerBankView
        row={selectedBank}
        product={row.game}
        numero={row.numero}
        date={date}
        rawDate={rawDate}
        tirage={tirage}
        onBack={() => setSelectedBank(null)}
      />
    );
  }

  const totalTickets = detail.reduce((s, r) => s + r.tickets, 0);
  const totalSold = detail.reduce((s, r) => s + r.sold, 0);
  const totalAmount = detail.reduce((s, r) => s + r.amount, 0);

  const limit = 30000;
  const posted = row.value;
  const available = limit - posted;

  return (
    <SupervisorLayout>
      <div className="svmdv-wrapper">
        <div className="svmdv-card">
          <div className="svmdv-card-header">
            <span className="svmdv-card-title">Move's Detail</span>
          </div>

          <div className="svmdv-info">
            <div className="svmdv-info-left">
              <div className="svmdv-numero-row">
                <span className="svmdv-borlette-label">{row.game} :</span>
                <span className="svmdv-numero-val">{row.numero}</span>
              </div>
              <div className="svmdv-info-row">
                <span className="svmdv-info-label">Date:</span>
                <span className="svmdv-info-box">{date}</span>
              </div>
              <div className="svmdv-info-row">
                <span className="svmdv-info-label">Lottery:</span>
                <span className="svmdv-info-box">{tirageName}</span>
              </div>
            </div>
            <div className="svmdv-info-right">
              <div className="svmdv-limit-row">
                <span className="svmdv-limit-label">Limit:</span>
                <span className="svmdv-limit-val">{limit.toLocaleString()}</span>
              </div>
              <div className="svmdv-limit-row">
                <span className="svmdv-limit-label">Posted:</span>
                <span>{Math.round(posted).toLocaleString()}</span>
              </div>
              <div className="svmdv-limit-row">
                <span className="svmdv-limit-label">Available:</span>
                <span>{Math.round(available).toLocaleString()}</span>
              </div>
            </div>
          </div>

          <div className="svmdv-table-header-bar"></div>

          {error && <p className="svmdv-error">{error}</p>}
          {loading && <p className="svmdv-loading">Chargement...</p>}

          {!loading && !error && (
            <table className="svmdv-table">
              <thead>
                <tr>
                  <th>Bank</th>
                  <th>Description</th>
                  <th>Tickets</th>
                  <th>Sold</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {detail.map((r, i) => (
                  <tr key={i} className={i % 2 === 0 ? 'svmdv-row-even' : 'svmdv-row-odd'}>
                    <td><span className="svmdv-bank-box">{r.bank_seq ?? r.bank}</span></td>
                    <td>
                      <span className="svmdv-desc-box svmdv-desc-link" onClick={() => setSelectedBank(r)}>
                        {r.desc}
                      </span>
                    </td>
                    <td>{r.tickets}</td>
                    <td>{r.sold.toFixed(2)}</td>
                    <td>{r.amount.toFixed(2)}</td>
                  </tr>
                ))}
                <tr className="svmdv-total-row">
                  <td colSpan="2"><strong>Total</strong></td>
                  <td><strong>{totalTickets}</strong></td>
                  <td><strong>{totalSold.toFixed(2)}</strong></td>
                  <td><strong>{totalAmount.toFixed(2)}</strong></td>
                </tr>
              </tbody>
            </table>
          )}
        </div>

        <div className="svmdv-actions">
          <button className="svmdv-back-btn" onClick={onBack}>↩</button>
          <button className="svmdv-menu-btn">☰<br/><span>Menu</span></button>
        </div>
      </div>
    </SupervisorLayout>
  );
};

export default SupervisorMoveDetailView;
